export function formatDate (d) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return d.getDate() + " " + monthNames[d.getMonth()] + " " + d.getFullYear() + " at " + strTime;
}

export function formatDateAbbr (d) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return d.getDate() + " " + monthNames[d.getMonth()] + " " + d.getFullYear() + ", " + strTime;
}

export function formatDateShort (d) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return d.getDate() + " " + monthNames[d.getMonth()] + " " + d.getFullYear();
}

export function formatDateDMY (d) {
    const retval = d.getDate().toString().padStart(2, '0') + '/' + (d.getMonth() + 1).toString().padStart(2, '0') + '/' + d.getFullYear();
    return retval;
}

// 2026-08-19: Year of Release entry only asks for a 4-digit year now (see
// TitleAddPage/TitleEditPage) -- release_date is still stored as a full Timestamp
// (Jan 1 of that year) so existing sort/range-query code across the client apps
// keeps working unchanged; this just formats it back down to the year for display.
export function formatYear (d) {
    return d.getFullYear().toString();
}